export default __webpack_public_path__ + "static/media/gallery - story - pot (1)_02.7f5be52a.jpg";